export const COUPON_LOAD_SUCCESS = 'coupon/LOAD_SUCCESS';
export const COUPON_CHANGE_SUCCESS = 'coupon/CHANGE_SUCCESS';
export const COUPON_UPDATE_SUCCESS = 'coupon/UPDATE_SUCCESS';
export const COUPON_CREATE_BARCODE = 'coupon/CREATE_BARCODE';
export const SET_BUSY = 'coupon/SET_BUSY';
export const UNSET_BUSY = 'coupon/UNSET_BUSY';
